type ActionableAccountRequestCount = {
  count: number;
};

export const useAccountRequestCount = () => {
  const count = useState<number>("actionable-account-request-count", () => 0);
  const loading = useState<boolean>("actionable-account-request-count-loading", () => false);
  const loaded = useState<boolean>("actionable-account-request-count-loaded", () => false);
  const apiFetch = useApiFetch();

  const load = async (force = false) => {
    if (loading.value || (loaded.value && !force)) {
      return;
    }

    loading.value = true;
    try {
      const response = await apiFetch<ActionableAccountRequestCount>("/tenants/requests/actionable-count");
      count.value = response.count;
      loaded.value = true;
    } catch {
      count.value = 0;
      loaded.value = false;
    } finally {
      loading.value = false;
    }
  };

  const reset = () => {
    count.value = 0;
    loaded.value = false;
  };

  const setCount = (value: number) => {
    count.value = value;
    loaded.value = true;
  };

  return {
    count: readonly(count),
    loading: readonly(loading),
    load,
    reset,
    setCount,
  };
};
